package music.jammers.client.shared.event.presentation.viewmodel

import kotlinx.datetime.LocalDateTime
import music.jammers.client.shared.component.track.presentation.model.TrackCardModel
import music.jammers.shared.event.domain.model.EventMember
import music.jammers.shared.event.domain.model.UserAcceptance
import music.jammers.shared.track.domain.model.Track
import music.jammers.shared.user.domain.model.User

data class EventDetailsState(
    val progress: Boolean = true,
    val eventId: Long = -1,
    val title: String? = null,
    val date: LocalDateTime? = null,
    val spot: String? = null,
    val tracks: List<EventDetailsItem> = emptyList(),
    val user: User? = null,
    val frozen: Boolean = false,
    val confirmSignInTrack: Pair<Track, EventMember>? = null,
    val confirmSignOutTrack: Pair<Track, EventMember>? = null,
    val userAcceptance: UserAcceptance? = null,
    val error: Throwable? = null,
)

sealed class EventDetailsItem {

    data object Header : EventDetailsItem()

    data class Item(val track: TrackCardModel) : EventDetailsItem()
}
